/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Export_ButtonInputs */

const en_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const de_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const ru_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const es_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const zh_cn2_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const ja_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const hi_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const pt_pt2_speakers_metrics_export_button = /** @type {(inputs: Speakers_Metrics_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Speakers_Metrics_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_export_button = /** @type {((inputs?: Speakers_Metrics_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_export_button(inputs)
	if (locale === "de") return de_speakers_metrics_export_button(inputs)
	if (locale === "it") return it_speakers_metrics_export_button(inputs)
	if (locale === "ru") return ru_speakers_metrics_export_button(inputs)
	if (locale === "es") return es_speakers_metrics_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_export_button(inputs)
	if (locale === "ja") return ja_speakers_metrics_export_button(inputs)
	if (locale === "hi") return hi_speakers_metrics_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_export_button(inputs)
	return en_speakers_metrics_export_button(inputs)
});